import { usePaginationContext } from './use-pagination-context';
export const PaginationContext = (props) => props.children(usePaginationContext());
